<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :title="$t('StockRules.Header.priority')"
    :visible.sync="dialogVisible"
    destroy-on-close
    width="500px"
  >
    <el-link type="warning" :underline="false">{{ $t('StockRules.Main.Drag') }}</el-link>
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      :header-cell-style="$rowStyle.DEFAULT"
      row-key="code"
      class="channel-sort-table-20220304"
      row-class-name="channel-sort-table-row-20220304"
    >
      <el-table-column prop="name" :label="$t('StockRules.Header.method')" />
      <el-table-column prop="code" :label="$t('StockRules.Header.priorit')" class-name="draggableItem">
        <template>
          <svg-icon icon-class="pointer" />
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="confirm">{{ $t('okText') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import Sortable from 'sortablejs';

export default {
  name: 'ChannelSort',
  data() {
    return {
      dialogVisible: false,
      propsData: [],
      tableData: [],
      key: null, // 附加值
    };
  },
  computed: {
    SCHL_CHANNEL_TYPE_LIST() {
      return this.$store.state.values['SCHL_CHANNEL_TYPE'] || [];
    },
  },
  watch: {
    SCHL_CHANNEL_TYPE_LIST(v) {
      this.tableData = this.getSortData();
    },
  },
  mounted() {
    this.$store.dispatch('values/getValueList', 'SCHL.CHANNEL_TYPE');
  },
  methods: {
    show(d, key) {
      this.tableData = this.getSortData(d);
      this.key = key;
      this.dialogVisible = true;

      setTimeout(() => {
        this.rowDrop();
      }, 1000);
    },
    // 行拖拽
    rowDrop() {
      // 此时找到的元素是要拖拽元素的父容器
      const tbody = document.querySelector(
        '.channel-sort-table-20220304 .el-table__body-wrapper tbody',
      );
      const _this = this;
      Sortable.create(tbody, {
        //  指定父元素下可被拖拽的子元素
        draggable: 'tr.channel-sort-table-row-20220304',
        handle: '.draggableItem',
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.tableData.splice(oldIndex, 1)[0];
          _this.tableData.splice(newIndex, 0, currRow);
        },
      });
    },
    getSortData(d) {
      if (d) this.propsData = [...d];
      const a = [...this.propsData];
      const b = this.SCHL_CHANNEL_TYPE_LIST.map(e => {
        return { code: e.value, name: e.meaning };
      });
      const BOT = b.filter(bb => {
        return !a.find(aa => bb.code == aa.code);
      });
      return [...a, ...BOT];
    },
    confirm() {
      this.handleClose();
      this.$emit('confirm', this.tableData, this.key);
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>
